/**
 * splash-screen.js — runs the wipe-out + dismisses the panel.
 *
 * Order of events on first paint:
 *   1. Browser renders the .c-splash overlay (CSS makes it cover the viewport).
 *   2. Wordmark fades + slides in via CSS @keyframes c-splash-mark.
 *   3. After splash-visible-ms ms, we set data-splash-revealing="true" on the
 *      panel. CSS picks that up and translates the panel up + fades it out.
 *   4. After splash-reveal-ms further ms, we set data-splash-removed="true"
 *      so the panel detaches from layout (display:none) — nothing intercepts
 *      pointer events going forward.
 *
 * Once-per-session: a successful run sets sessionStorage["splash:seen"]=1.
 * On subsequent navs we mark the panel revealed/removed immediately so the
 * page paints normally and JS doesn't re-run the animation.
 *
 * Reduced-motion: skip step 3, jump straight to step 4 (no wipe animation).
 */
(function () {
  'use strict';
  var KEY = 'splash:seen';
  var panel = document.querySelector('[data-splash]');
  if (!panel) return;

  var seen = false;
  try { seen = sessionStorage.getItem(KEY) === '1'; } catch (_) { /* private mode */ }

  if (seen) {
    panel.setAttribute('data-splash-revealing', 'true');
    panel.setAttribute('data-splash-removed', 'true');
    return;
  }

  var prefersReduced = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var visibleMs = parseInt(getComputedStyle(panel).getPropertyValue('--splash-visible-ms'), 10) || 1400;
  var revealMs = parseInt(getComputedStyle(panel).getPropertyValue('--splash-reveal-ms'), 10) || 800;

  if (prefersReduced) {
    // Skip the animation entirely — flash the wordmark briefly then remove.
    setTimeout(function () {
      panel.setAttribute('data-splash-revealing', 'true');
      panel.setAttribute('data-splash-removed', 'true');
      try { sessionStorage.setItem(KEY, '1'); } catch (_) { }
    }, Math.min(visibleMs, 800));
    return;
  }

  // Step 3: trigger wipe-out.
  setTimeout(function () {
    panel.setAttribute('data-splash-revealing', 'true');
  }, visibleMs);

  // Step 4: detach from layout once wipe finishes so pointer events flow.
  setTimeout(function () {
    panel.setAttribute('data-splash-removed', 'true');
    try { sessionStorage.setItem(KEY, '1'); } catch (_) { }
  }, visibleMs + revealMs + 50);
})();
